<section class="tender-guidelines">
  <div class="tender-guidelines__header">
    <span class="tender-guidelines__header-icon">
      <i class="iconsax" icon-name="tick-circle"></i>
    </span>
    <h2 class="tender-guidelines__title">
      {{ 'tenders.legalGuidelinesTitle' | translate }}
    </h2>
  </div>

  <div class="tender-guidelines__grid">
    <article class="tender-guidelines__item">
      <h3 class="tender-guidelines__item-title">
        {{ 'tenders.bindingAgreements' | translate }}
      </h3>
      <p class="tender-guidelines__item-text">
        {{
          'tenders.bindingAgreementsDesc'
            | translate
              : {
                  amount: tender()?.amount?.value,
                  unit:
                    ('enums.measurements.' + tender()?.amount?.unit | translate),
                  title: (tender()?.title | translateData),
                }
        }}
      </p>
    </article>

    <article class="tender-guidelines__item">
      <h3 class="tender-guidelines__item-title">
        {{ 'tenders.shippingDemurrage' | translate }}
      </h3>
      <p class="tender-guidelines__item-text">
        {{
          'tenders.shippingDemurrageDesc'
            | translate
              : {
                  address:
                    (tender()?.delivery_city?.name | translateData) ||
                    (tender()?.delivery_address | translateData) ||
                    '-',
                }
        }}
      </p>
    </article>

    <article class="tender-guidelines__item">
      <h3 class="tender-guidelines__item-title">
        {{ 'tenders.jointArbitration' | translate }}
      </h3>
      <p class="tender-guidelines__item-text">
        {{ 'tenders.jointArbitrationDesc' | translate }}
      </p>
    </article>
  </div>
</section>
